import { List, Map, Record } from "immutable";

export const COURSE_SECTIONS_SPEC_TYPE: "course-sections" = "course-sections";

export type CourseSectionsSpecType = {
  courseId: string | null;
  sectionIds: List<string>;
  sectionContentIds?: Map<string, List<string>>;
  questionIds: List<string>;
};

type CourseSectionsSpecJS = {
  courseId: string;
  sectionIds: string[];
  sectionContentIds?: {
    [sectionId: string]: string[];
  };
  questionIds: string[];
};

const defaultCourseSectionsSpec: CourseSectionsSpecType = {
  courseId: null,
  sectionIds: List(),
  sectionContentIds: undefined,
  questionIds: List()
};

export default class CourseSectionsSpec extends Record(
  defaultCourseSectionsSpec
) {}

export function fromJS(values: CourseSectionsSpecJS): CourseSectionsSpec {
  const sectionContentIds = values.sectionContentIds
    ? Map<string, List<string>>(
        Object.keys(values.sectionContentIds).reduce(
          (acc, sectionId) => ({
            ...acc,
            [sectionId]: List(values.sectionContentIds![sectionId])
          }),
          {}
        )
      )
    : undefined;

  return new CourseSectionsSpec({
    ...values,
    sectionIds: List(values.sectionIds),
    sectionContentIds,
    questionIds: List(values.questionIds)
  });
}
